import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import branch from 'recompose/branch';
import renderNothing from 'recompose/renderNothing';
import withHandlers from 'recompose/withHandlers';
import { markAsSeenAction } from '../../redux/notifications';
import Modal from '../Modal';
import Button from '../Button';
import styles from './Notification.css';
import Close from '../Icons/Close';
import IconButton from '../IconButton';

const Notification = ({
    icon: Icon,
    to,
    title,
    text,
    button,
    hide,
    close,
}) => <Modal
    className={styles.modal}
    fill="modal"
    onClose={close ? hide : undefined}
    open
>
    {close ? <IconButton
        aria-label="Close Notification"
        className={styles.close}
        onClick={hide}
        icon={Close}
        iconProps={{
            size: 15,
        }}
    /> : null}
    {Icon ? <Icon /> : null}
    <h2> {title} </h2>
    <p>
        {text}
    </p>
    <Button
        to={to}
        className={styles.action}
        onClick={hide}
    >
        {button}
    </Button>
</Modal>;

Notification.propTypes = {
    icon: PropTypes.func,
    to: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.node,
    button: PropTypes.string,
    hide: PropTypes.func,
    close: PropTypes.bool,
};

export const withNotification = compose(
    connect(({ notifications }, { type }) => ({
        hidden: !!notifications[type],
    }), {
        markAsSeen: markAsSeenAction,
    }),
    withHandlers({
        hide: props => () => {
            props.markAsSeen(props.type);
        },
    }),
    branch(({ hidden }) => hidden, renderNothing),
);

export default withNotification(Notification);



// WEBPACK FOOTER //
// ./src/client/Components/Notification/Notification.js